import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_9 = { class: "invalid-feedback" };
const _hoisted_10 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-6 bottom10"
};
const _hoisted_11 = {
    class: "fa fa-question-circle",
    title: "Set to 0 to ignore Ohmic Rise filtering and include all blocks with predictions or alarms"
};
const _hoisted_12 = { class: "invalid-feedback" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_14 = { class: "checkbox-wrapper" };
const _hoisted_15 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d;
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _cache[5] || (_cache[5] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[20] || (_cache[20] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select a Company",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[21] || (_cache[21] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Select a Site",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[22] || (_cache[22] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "\r\n\t\t\tPeriod in Months\r\n\t\t", -1 /* CACHED */)),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createVNode(_component_b_form_input, _mergeProps(_ctx.periodInMonthsVal, {
                type: "number",
                modelValue: _ctx.query.periodInMonths,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.periodInMonths) = $event)),
                modelModifiers: { trim: true },
                min: "1",
                max: "60",
                step: "1",
                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.periodInMonths }
            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", _hoisted_9, "\r\n\t\t\t* Please enter a value between 1 and 60.\r\n\t\t", 512 /* NEED_PATCH */), [
                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.periodInMonths]
            ])
        ]),
        _cache[23] || (_cache[23] = _createTextVNode()),
        (_ctx.isClientAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", null, [
                    _cache[11] || (_cache[11] = _createTextVNode("\r\n\t\t\tOhmic Rise Threshold (%) \r\n\t\t\t", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("i", _hoisted_11, null, 512 /* NEED_PATCH */), [
                        [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                        ]
                    ])
                ]),
                _cache[12] || (_cache[12] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseThresholdVal, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseThreshold,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.ohmicRiseThreshold) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.ohmicRiseThreshold }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_12, "\r\n\t\t\t* Please enter a value between 0 and 100.\r\n\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.ohmicRiseThreshold]
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[24] || (_cache[24] = _createTextVNode()),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.query.includeOhmicColumns,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.includeOhmicColumns) = $event)),
                    name: "includeOhmicColumns",
                    value: "true",
                    "unchecked-value": "false",
                    size: "lg"
                }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("\r\n\t\t\t\tInclude Ohmic Columns\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _cache[25] || (_cache[25] = _createTextVNode()),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "float-start top10 ms-2" }, [
            _createElementVNode("label", null, "Note: the battery replacement estimation calculations are performed every seven days.")
        ], -1 /* CACHED */)),
        _cache[27] || (_cache[27] = _createTextVNode()),
        _createElementVNode("div", _hoisted_15, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _cache[18] || (_cache[18] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToPdf
            }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export PDF\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _cache[19] || (_cache[19] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToCsv
            }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export CSV\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _cache[28] || (_cache[28] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
